// Sistema de diseño — Sushiito Admin.
// Fuente única de colores/tipografía/componentes base. Ver la propuesta
// visual (aprobada por Ari 2026-07-19, "Opción A: dorado y carbón") antes de
// tocar valores aquí — este archivo homologa lo que antes cada pantalla
// improvisaba por su cuenta.

export const colors = {
  ink: "#201c16",
  inkSoft: "#6b6459",
  paper: "#f7f4ef",
  surface: "#ffffff",
  line: "#e7e1d6",
  gold: "#c8a96e",
  goldInk: "#8a6a34",
  goldBg: "#f5ecd8",
  charcoal: "#171310",
  success: "#1e7a46",
  successBg: "#e7f5eb",
  warning: "#9c6b0a",
  warningBg: "#fbf1dc",
  danger: "#b23a2e",
  dangerBg: "#fbeae7",
  sushiito: "#1d5a96",
  urban: "#8c3527"
};

// Regla (2026-07-19, Ari pidió una sola tipografía en toda la app, sin
// excepciones — ni siquiera en títulos): todo usa font.sans. font.serif se
// deja como alias del mismo valor únicamente por si algún archivo viejo
// todavía lo referencia — no usar Georgia en ningún lado nuevo.
export const font = {
  serif: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  sans: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
};

export const shadow = "0 1px 2px rgba(32,28,22,0.04), 0 8px 24px rgba(32,28,22,0.06)";

// Estado de un dato: activo/cumple, por vencer/pendiente, vencido/no cumple/crítico.
const PILL_VARIANTS = {
  success: { background: colors.successBg, color: colors.success },
  warning: { background: colors.warningBg, color: colors.warning },
  danger: { background: colors.dangerBg, color: colors.danger },
  neutral: { background: "#eef0f3", color: colors.inkSoft }
};
export function pillStyle(variant = "neutral") {
  return {
    display: "inline-block", padding: "3px 11px", borderRadius: "20px",
    fontSize: "11.5px", fontWeight: "600", fontFamily: font.sans,
    ...(PILL_VARIANTS[variant] || PILL_VARIANTS.neutral)
  };
}

export function buttonStyle(variant = "primary") {
  const base = {
    border: "none", borderRadius: "8px", padding: "10px 18px", fontSize: "13.5px",
    fontWeight: "600", cursor: "pointer", fontFamily: font.sans
  };
  if (variant === "primary") return { ...base, background: colors.gold, color: "#2a2218" };
  if (variant === "secondary") return { ...base, background: "transparent", border: `1px solid ${colors.line}`, color: colors.ink };
  if (variant === "danger") return { ...base, background: "transparent", border: `1px solid ${colors.danger}`, color: colors.danger };
  return base;
}

export const cardStyle = {
  background: colors.surface, border: `1px solid ${colors.line}`, borderRadius: "12px",
  padding: "20px", boxShadow: shadow
};

export const cardTitleStyle = { fontFamily: font.serif, fontWeight: "normal", fontSize: "17px", color: colors.ink, margin: "0 0 4px" };
export const cardSubStyle = { fontSize: "13px", color: colors.inkSoft, margin: 0, fontFamily: font.sans };

export const tableStyle = { width: "100%", borderCollapse: "collapse", fontSize: "13.5px" };
export const thStyle = {
  textAlign: "left", padding: "8px 10px", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.4px",
  color: colors.inkSoft, fontWeight: "700", borderBottom: `2px solid ${colors.line}`, fontFamily: font.sans
};
export const tdStyle = { padding: "8px 10px", borderBottom: `1px solid ${colors.line}`, fontFamily: font.sans, color: colors.ink };
